import { haflaSaraNumber } from 'config/common';

const isProduction = process.env.NEXT_PUBLIC_APP_ENV === 'production';

const getInitiateWhatsappChatLinkForSARA = ({
  messageBody = 'Hi Sara! I want to partner with Hafla'
} = {}) => {
  const messagePrefix = isProduction
    ? ''
    : `Please Ignore this - this message is from the non production portal. \n\n`;

  const whatsAppBaseURL = 'https://api.whatsapp.com/send';

  const formattedMessage = `${messagePrefix}${messageBody}`;

  return `${whatsAppBaseURL}?phone=${haflaSaraNumber}&text=${encodeURIComponent(formattedMessage)}`;
};

export default getInitiateWhatsappChatLinkForSARA;
